export default {
  en: {
    // Product Mix Trend
    'productMixTrend': 'Product Mix Trend',
    'byDate': 'By Date',
    'byStore': 'By Store',

    // RFM Price Comparison
    'rfm-price-comparison': 'RFM Price Comparison',
    'search': 'Search',
    'menu-item-number': 'Menu Item #',
    'menu-price': 'Menu Price',
    'price': 'Price',
    'delivery-price': 'Delivery Price',
    'delivery-price-is-other-price-in-rfm': 'Delivery Price is Other price in RFM',
    'delivery-premium': 'Delivery Premium',
    'indicates-that-delivery-price-is-less': 'indicates that Delivery Price is less than your lower threshold',
    'indicates-that-delivery-price-is-greater': 'indicates that Delivery Price is greater than your upper threshold',
    'delivery': 'Delivery',
    'group': 'Group',

    // RFM Threshold Settings
    'delivery-premium-thresholds': 'Delivery Premium Thresholds',
    'upper-threshold': 'Upper Threshold',
    'lower-threshold': 'Lower Threshold',
    'close': 'Close',
    'reset': 'Reset',
    'save': 'Save',

    // Delivery Price Index
    'delivery-price-index': 'Delivery Price Index',
    'delivery-premium-desc': '(Delivery price minus Non-delivery price) divided by Non Delivery Price',
    'delivery-price-desc': 'Menu Item price for an item sold in a delivery order',
    'non-delivery-price': 'Non-Delivery Price',
    'non-delivery-price-desc': 'Price of menu item on non-delivery orders (usually matches to RFM EAT IN and TAKE OUT price)',
    'description': 'Description',
    'description-desc': 'Menu Item Description',
    'menu-item-number-desc': 'The Menu Item number',

    // PMIX Discount
    'by-date': 'By Date',
    'pmix-discount': 'PMIX Discount',
    'price-after-offer': 'Price After Offer',
    'total-offer-$': 'Total Offer $',
    'unit-offer-$': 'Unit Offer $',
    'offer-qty': 'Offer Qty',
    'menu-item-description': 'Menu Item Description',
    'offer-name': 'Offer Name',
    'name-of-discount-from-digital-app-or-pos-system': 'Name of Discount from Digital App or POS system',

    // Product Mix (Pmix)
    'four-days-ago': '4 Days Ago',
    'grubhub-warning': 'Grubhub 3PO order accuracy data is not currently available',
    'second-warning': 'Reports receive 3PO McDelivery data 3 days after the business date at 5:45 PM CST. First day available in reports is 4 days prior',
    'product-mix': 'Product Mix',
    'product-mix-analysis': 'Product Mix Analysis',
    'wrap-combo-units-sold-based-off-of': 'Wrap Combo Units Sold are based off the menu item, therefore the 2 wrap menu items will need to be multiplied by 2 to get total single units sold.',
    'live': 'Live',

    // Kitchen Capacity
    'kitchen-capacity': 'Kitchen Capacity',

    // Product Outage
    'all-outages': 'All Outages',
    'current-outages': 'Current Outages',
    'reported-product-outage': 'Reported Product Outage',
    'the-menu-item-number': 'The menu item number',
  },
  es: {
    // Product Mix Trend
    'productMixTrend': 'Tendencia de mezcla de productos',
    'byDate': 'Por fecha',
    'byStore': 'Por tienda',

    // RFM Price Comparison
    'rfm-price-comparison': 'Comparación de precios de RFM',
    'search': 'Buscar',
    'menu-item-number': 'Artículo del Menú #',
    'menu-price': 'Precio del Menú',
    'price': 'Precio',
    'delivery-price': 'Precio de Entrega',
    'delivery-price-is-other-price-in-rfm': 'El precio de entrega es otro precio en RFM',
    'delivery-premium': 'Prima de Entrega',
    'indicates-that-delivery-price-is-less': 'indica que el Precio de Entrega es menos (o menor) que su umbral inferior',
    'indicates-that-delivery-price-is-greater': 'indica que el Precio de Entrega es mas (o mayor) que su umbral superior',
    'delivery': 'Entrega',
    'group': 'Grupo',

    // RFM Threshold Settings
    'delivery-premium-thresholds': 'Umbrales de prima de entrega',
    'upper-threshold': 'Umbral superior',
    'lower-threshold': 'Umbral inferior',
    'close': 'Cerrar',
    'reset': 'Reiniciar',
    'save': 'Guardar',

    // Delivery Price Index
    'delivery-price-index': 'Índice de Precios de Entrega',
    'delivery-premium-desc': '(Precio de entrega menos precio sin entrega) dividido por precio sin entrega',
    'delivery-price-desc': 'Precio del artículo del menú para un artículo vendido en un pedido de entrega',
    'non-delivery-price': 'Precio sin Entrega',
    'non-delivery-price-desc': 'Precio del artículo del menú en pedidos sin entrega (usualmente coincide con el precio de RFM PARA COMER EN EL LOCAL y PARA LLEVAR)',
    'description': 'Descripción',
    'description-desc': 'Descripción del Artículo del Menú',
    'menu-item-number-desc': 'El número del Artículo del Menú',

    // PMIX Discount
    'by-date': 'Por Fecha',
    'pmix-discount': 'Descuento PMIX',
    'price-after-offer': 'Precio Después de la Oferta',
    'total-offer-$': 'Total de Oferta $',
    'unit-offer-$': 'Unidad de Oferta $',
    'offer-qty': 'Cantidad de Oferta',
    'menu-item-description': 'Descripción del Artículo del Menú',
    'offer-name': 'Nombre de la Oferta',
    'name-of-discount-from-digital-app-or-pos-system': 'Nombre del Descuento de la Aplicación Digital o del Sistema Punto de Venta',

    // Product Mix (Pmix)
    'four-days-ago': 'Hace 4 días',
    'grubhub-warning': 'Los datos de precisión de pedidos de Grubhub 3PO no están disponibles actualmente',
    'second-warning': 'Los informes reciben datos de 3PO McDelivery 3 días después de la fecha comercial a las 5:45 PM CST. El primer día disponible en los informes es 4 días antes',
    'product-mix': 'Product Mix',
    'product-mix-analysis': 'Análisis de Product Mix',
    'wrap-combo-units-sold-based-off-of': 'Las unidades vendidas de Wrap Combo se basan en el artículo del menú; por lo tanto, los 2 artículos de Wrap deben multiplicarse por 2 para obtener el total de unidades individuales vendidas.',
    'live': 'En vivo',

    // Kitchen Capacity
    'kitchen-capacity': 'Capacidad de Cocina',

    // Product Outage
    'all-outages': 'Todas las interrupciones',
    'current-outages': 'Interrupciones actuales',
    'reported-product-outage': 'Interrupción de producto reportada',
    'the-menu-item-number': 'El número de artículo del menú',
  },
};
